// signin.tsx
import AuthLayout from "./AuthPageLayout";
import SignInForm from "../../components/auth/SignInForm";
import PageMeta from "../../shared/PageMeta";

export default function SignIn() {
  return (
    <>
      <PageMeta
        title="SignIn Dashboard "
        description=""
      />
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}